import type { AppearanceModule } from '@setplex/tria-api'

import { STATIC_IDENTIFIERS } from '~/shared/appearance'

const NAME_TO_IDENTIFIER: Record<string, string> = {
  catchups: STATIC_IDENTIFIERS.CATCHUP,
  epg: STATIC_IDENTIFIERS.EPG,
  event: STATIC_IDENTIFIERS.EVENT,
  home: STATIC_IDENTIFIERS.HOME,
  library: STATIC_IDENTIFIERS.LIBRARY,
  live: STATIC_IDENTIFIERS.TV,
  movie: STATIC_IDENTIFIERS.VOD,
  partner: STATIC_IDENTIFIERS.HOME, // there is no partner module, map to home instead
  search: STATIC_IDENTIFIERS.SEARCH,
  series: STATIC_IDENTIFIERS.SHOW,
  settings: STATIC_IDENTIFIERS.SETTINGS,

  // old names mapping
  events: STATIC_IDENTIFIERS.EVENT,
  movies: STATIC_IDENTIFIERS.VOD,
  shows: STATIC_IDENTIFIERS.SHOW,
  tv: STATIC_IDENTIFIERS.TV,
  'partner-program': STATIC_IDENTIFIERS.HOME, // there is no partner module, map to home instead
}

const OMIT_MODULES = ['search', 'settings', 'library']

export function actualIdentifier({
  selected,
  modules,
}: {
  selected: string | null
  modules: AppearanceModule[] | null
}): string {
  const [space, name] = window.location.pathname.split('/').filter(Boolean)
  let actual = selected

  // if we are in /modules/xyz, then override selected with actual module identifier
  if (space === 'modules') {
    actual = NAME_TO_IDENTIFIER[name] || name
  }

  // if we are in /content/xyz, then fallback to content name to module identifier map,
  // but only if selected is not set (not previously saved in local storage)
  else if (space === 'content') {
    if (
      !selected ||
      selected === STATIC_IDENTIFIERS.LIBRARY ||
      selected === STATIC_IDENTIFIERS.SEARCH
    ) {
      actual = NAME_TO_IDENTIFIER[name] || name
    }
  }

  // reset actual if selected is not a module (e.g. terms of agreement, privacy policy, etc)
  else if (space !== 'player' && !(space in NAME_TO_IDENTIFIER)) {
    actual = ''
  }

  // validate actual identifier against available modules
  // and fallback to home if not found
  if (modules && actual && !OMIT_MODULES.includes(actual)) {
    const mod = modules.find((m) => m.identifier === actual)
    if (!mod) {
      actual = STATIC_IDENTIFIERS.HOME
    }
  }

  // in any other case, fallback to home, if actual is still not set
  return actual ?? STATIC_IDENTIFIERS.HOME
}
